export default __webpack_public_path__ + "static/media/Icons.fda7cfc2.svg";